import cn from 'classnames';
import { IColumn } from '@creditflowresearch/uilib/Table/DataTable/interfaces/Column';
import { TagsCell } from '@/creditflowresearch/ui/common/components/TableCells';
import NameCell from '@/creditflowresearch/ui/components/creditFlow/Stats/StatsTable/cellCallbacks/NameCell';
import UpdatedAtCell from '@/creditflowresearch/ui/components/creditFlow/Stats/StatsTable/cellCallbacks/UpdatedAtCell';
import AttributeCell from '@/creditflowresearch/ui/components/creditFlow/Stats/StatsTable/cellCallbacks/AttributeCell';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';
import textStyles from '@creditflowresearch/uilib/styles/helpers/text.module.scss';

const columns: IColumn[] = [
  {
    title: 'Name',
    name: 'name',
    cellCallback: NameCell,
  },
  {
    title: 'Categories',
    name: 'categoriesNames',
    maxWidth: 350,
    className: cn(alignStyles.alignRight, textStyles.nowrap),
    cellCallback: TagsCell,
  },
  {
    title: 'Product',
    name: 'products',
    width: 115,
    maxWidth: 115,
    cellCallback: (cellProps) => <AttributeCell { ...cellProps } countItemVisible={ 3 } />,
  },
  {
    title: 'Region',
    name: 'regions',
    width: 120,
    maxWidth: 120,
    cellCallback: AttributeCell,
  },
  {
    title: 'Date',
    name: 'updatedAt',
    width: 113,
    maxWidth: 113,
    className: cn(alignStyles.alignRight, textStyles.nowrap),
    cellCallback: (cellProps) => <UpdatedAtCell row={ cellProps.row } />,
  },
];

export default columns;
